var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-toolbar",
        { attrs: { color: "primary", dark: "" } },
        [
          _c("span", [_vm._v("Purchase Request")]),
          _c("v-spacer"),
          _c("v-icon", [_vm._v("mdi-account")])
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          items: _vm.purchaseRequestIndexList,
          headers: _vm.headers,
          loading: _vm.purchaseRequestIndexGetting,
          "server-items-length": _vm.purchaseRequestIndexGetCount,
          "single-expand": "",
          page: _vm.page,
          "items-per-page": _vm.itemsPerPage
        },
        on: {
          "update:page": function($event) {
            _vm.page = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function() {
              return [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "3" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            label: "Search",
                            "append-icon": "mdi-magnify"
                          },
                          model: {
                            value: _vm.search,
                            callback: function($$v) {
                              _vm.search = $$v
                            },
                            expression: "search"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "item",
            fn: function({ item, expand, isExpanded }) {
              return [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(item.purchase_request_no))]),
                  _c("td", [_vm._v(_vm._s(_vm.prAmount(item).phpFormat()))]),
                  _c("td", [_vm._v(_vm._s(item.status.description))]),
                  _c(
                    "td",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "yellow", text: "", small: "" },
                          on: {
                            click: function($event) {
                              return _vm.$router.push({
                                name: "purchase-request.edit",
                                params: { purchaseRequest: item.id }
                              })
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-pencil")])],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "green", text: "", small: "" },
                          on: {
                            click: function($event) {
                              return _vm.$router.push({
                                name: "purchase-request.detail.edit",
                                params: { purchaseRequest: item.id }
                              })
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-poll")])],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "blue-grey", text: "", small: "" },
                          on: {
                            click: function($event) {
                              return expand(!isExpanded)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            { class: isExpanded ? "is-expanded" : "" },
                            [_vm._v("mdi-chevron-down")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          },
          {
            key: "expanded-item",
            fn: function({ item }) {
              return [
                _c("tr", [
                  _c(
                    "td",
                    { attrs: { colspan: "4" } },
                    [
                      _c("v-simple-table", {
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function() {
                                return [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", [_vm._v("Stock")]),
                                      _c("th", [_vm._v("Qty")]),
                                      _c("th", [_vm._v("Unit")]),
                                      _c("th", [_vm._v("Cost")])
                                    ])
                                  ]),
                                  _c(
                                    "tbody",
                                    [
                                      _vm._l(item.details, function(
                                        detail,
                                        index
                                      ) {
                                        return _c("tr", { key: index }, [
                                          _c("td", [
                                            _vm._v(_vm._s(detail.stock_id))
                                          ]),
                                          _c("td", [
                                            _vm._v(_vm._s(detail.quantity))
                                          ]),
                                          _c("td", [
                                            _vm._v(_vm._s(detail.unit))
                                          ]),
                                          _c(
                                            "td",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                _vm._s(detail.cost.phpFormat())
                                              )
                                            ]
                                          )
                                        ])
                                      }),
                                      _c("tr", [
                                        _c("th", { attrs: { colspan: "3" } }, [
                                          _vm._v("Total")
                                        ]),
                                        _c(
                                          "td",
                                          { staticClass: "text-right" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.prAmount(item).phpFormat()
                                              )
                                            )
                                          ]
                                        )
                                      ])
                                    ],
                                    2
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }